<template>
  <el-container>
    <el-main>
      <el-col :span="24">
        <el-card class="box-card">
          <h4 class="card-title">Cerificates Due</h4>

          <data-tables-server
            class="table-shopping"
            style="width: 100%"
            layout="table"
            :data="certificates"
            :loading="loadingCertificates"
          >
            <el-table-column label="Select" width="90">
              <template slot-scope="props">
                <el-checkbox
                  :checked="props.row.boughtProducts[0].certSent==1?true:false"
                  @change="setSent(props.row.boughtProducts[0].orderId,props.row.boughtProducts[0].id,props.row.boughtProducts[0].certSent)"
                  v-model="props.row.boughtProducts[0].certSent"
                  :disabled="sending"
                ></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column label="Approve" width="150">
              <template slot-scope="props">
                <el-checkbox
                  :checked="props.row.boughtProducts[0].certDue==1?true:false"
                  @change="setApproved(props.row.boughtProducts[0].id,props.row.boughtProducts[0].certDue)"
                  v-model="props.row.boughtProducts[0].certDue"
                  :disabled="approving"
                ></el-checkbox>
                <el-popover placement="right" width="400" trigger="click" visible-arrow="true">
                  <transition name="el-loading-fade">
                    <div v-show="loadingProgress" class="el-loading-mask">
                      <div class="el-loading-spinner">
                        <svg viewBox="25 25 50 50" class="circular">
                          <circle cx="50" cy="50" r="20" fill="none" class="path" />
                        </svg>
                        <!---->
                      </div>
                    </div>
                  </transition>
                  <div v-for="course in progress" v-show="!loadingProgress">
                    <el-progress
                      :stroke-width="20"
                      :loading="loadingProgress"
                      :text-inside="true"
                      :percentage="Number((course.enrollmentCurrentPoints/course.courseMaximumPoints)*100).toFixed(2)"
                    ></el-progress>
                    {{course.courseName}} - {{course.enrollmentStatus}}
                  </div>

                  <el-button
                    slot="reference"
                    size="mini"
                    @click="getLMSProgress(props.row.customer.email)"
                  >
                    <i class="fa fa-bar-chart-o"></i>
                  </el-button>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="LOR" min-width="10">
              <template slot-scope="props">
                <div
                  v-show="props.row.boughtProducts[0].product.type=='combined course' || props.row.boughtProducts[0].product.type=='classroom course'"
                >
                  <a
                    class="btn btn-primary"
                    v-if="props.row.boughtProducts[0].classRoomLorSourceUrl"
                    :href="props.row.boughtProducts[0].classRoomLorSourceUrl.substring(0,3)=='app' ? 'https://crm.tefl.org.uk/'+props.row.boughtProducts[0].classRoomLorSourceUrl : props.row.boughtProducts[0].classRoomLorSourceUrl"
                    target="_blank"
                  >View</a>
                  <a
                    class="btn btn-danger"
                    v-if="!props.row.boughtProducts[0].classRoomLorSourceUrl"
                    href="#"
                  >No LOR</a>
                  <span v-if="!props.row.boughtProducts[0].classRoomLorSourceUrl">ok</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Address" min-width="10">
              <template slot-scope="props">
                <i
                  class="fa"
                  :class="{'fa-times':!props.row.customer.shippingAddress || !props.row.customer.shippingAddress.line1,'fa-check':props.row.customer.shippingAddress && props.row.customer.shippingAddress.line1}"
                ></i>
              </template>
            </el-table-column>
            <el-table-column label="ID" min-width="10">
              <template slot-scope="props">{{props.row.customer.id}}</template>
            </el-table-column>
            <el-table-column label="Name" min-width="20">
              <template slot-scope="props">
                <a
                  :href="'/#/customer/edit/'+props.row.customer.id"
                >{{props.row.customer.firstname}} {{props.row.customer.lastname}}</a>
                {{props.row.customer.email}}
              </template>
            </el-table-column>

            <el-table-column label="Course" min-width="40">
              <template slot-scope="props">
                {{props.row.boughtProducts[0].product.name}}
                <br />
                {{props.row.boughtProducts[0].product.type}}
              </template>
            </el-table-column>
          </data-tables-server>
          <br />
          <el-button type="primary" @click="printCerts" :loading="loadingCertificates">
            <i class="fa fa-certificate"></i>Certificates
          </el-button>
          <el-button type="info" @click="printLabels" :loading="loadingLabels">
            <i class="fa fa-address-card-o"></i>Labels
          </el-button>
          <el-button type="success" @click="printLors" :loading="loadingLors">
            <i class="fa fa-file-o"></i> Lors
          </el-button>
        </el-card>
      </el-col>
    </el-main>
  </el-container>
</template>
<script>
import gql from "graphql-tag";
import datas from "./api";
import LMSapi from "../../api/lmsAPI";
import serverApi from "../../api/serverAPI";
import _ from "lodash";
import { getName } from "country-list";
import moment from "moment";
export default {
  data() {
    return {
      certificates: [],
      selectedCerts: [],
      loadingCertificates: false,
      loadingLabels: false,
      loadingLors: false,
      loadingProgress: false,
      approving: false,
      sending: false,
      progress: [],
      certURL: null,
      loading: false,
      selectedIds: [],

      multipleSelection: []
    };
  },
  methods: {
    getCertificatesDue() {
      this.loadingCertificates = true;
      this.$apollo
        .query({
          query: gql`
            {
              Order(
            
                where: {
                  customerId: { _neq: null }
                  status: { _eq: "2" }
                  boughtProducts: {
                    _and: {
                      orderId: { _is_null: false }
                      certDue: { _eq: "0" }
                      orderPaymentStatus: { _eq: "2" }
                      _or: [
                        {
                          _and: { product: { type: { _eq: "online course" } } }
                          onlineCoursePassed: { _eq: "1" }
                        }
                        {
                          _and: {
                            product: { type: { _eq: "classroom course" } }
                          }
                          classRoomCoursePassed: { _eq: "1" }
                        }
                        {
                          _and: {
                            product: { type: { _eq: "combined course" } }
                          }
                          classRoomCoursePassed: { _eq: "1" }
                          onlineCoursePassed: { _eq: "1" }
                        }
                      ]
                    }
                  }
                }
              ) {
                boughtProducts(
                  where: {
                    certDue: { _eq: "0" }
                    _or: [
                        {
                          _and: { product: { type: { _eq: "online course" } } }
                          onlineCoursePassed: { _eq: "1" }
                        }
                        {
                          _and: {
                            product: { type: { _eq: "classroom course" } }
                          }
                          classRoomCoursePassed: { _eq: "1" }
                        }
                        {
                          _and: {
                            product: { type: { _eq: "combined course" } }
                          }
                          classRoomCoursePassed: { _eq: "1" }
                          onlineCoursePassed: { _eq: "1" }
                        }
                      ]
                    product: {
                      type: {
                        _in: [
                          "online course"
                          "classroom course"
                          "combined course"
                        ]
                      }
                    }
                  }
                ) {
                  id
                  classRoomCoursePassed
                  onlineCoursePassed
                  classRoomLorSourceUrl
                  certSent
                  certDue
                  orderId
                  product {
                    certificateText
                    certificateSmallText
                    type
                    course {
                      type
                    }
                    learningOutcomes
                    name
                  }
                }
                status
                customer {
                  id
                  firstname
                  middlenames
                  email
                  title
                  shippingAddress {
                    line1
                    line2
                    country
                    town
                    region
                    postcode
                  }
                  lastname
                  lor {
        id
      }
                }
                id
              }
            }
          `,
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.certificates = response.data.Order;
          this.certificates;
          this.loadingCertificates = false;
        });
    },

    setSent(order_id, obp_id, val) {
      this.sending = true;
      if (obp_id) {
        let sentDate =
          val == "1" ? '"' + moment().format("YYYY-MM-DD") + '"' : null;

        let dd = gql`
          mutation updateSent{
              update_OrderBoughtProduct(where: {id: {_eq: ${obp_id}}}, _set: {certSent: ${
                    val ? 1 : 0
                  },certSentDate:${sentDate}}) {
              returning {
                id
              }
              }
        }`;
        this.$apollo
          .mutate({
            mutation: dd
          })
          .then(response => {
            datas
              .saveCertUrl({ order_id: order_id, obp_id: obp_id })
              .then(response => {
                console.log(response);
                this.sending = false;
                this.$notify({
                  title: "Success",
                  message: "Certificate marked as sent",
                  type: "success"
                });
              });
          });
      }
    },
    selectAll(rows) {
      console.log(rows);
      if (rows) {
        rows.forEach(row => {
          console.log(row);
          this.$refs.certTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.certTable.clearSelection();
      }
    },
    setApproved(id, val) {
      this.approving = true;
      console.log(id +":" +val)
      if (id ) {
        let dd = gql`
          mutation updateApproved{
            update_OrderBoughtProduct(
              where: {id: {_eq: ${id}}}, 
              _set: {certDue: ${val ? 1 : 0}}
            ) {
              returning {
                id
              }
            }
          }`;
        this.$apollo.mutate({
          mutation: dd
        });
        serverApi.post('/certificates/saveCertUrl',{obp_id:id}).then((result)=>{
          console.log(result)
          this.approving = false;
          if(result.data){
          this.$notify({
            title: "Success",
            message: "Certificate Approved",
            type: "success"
          });}
          else{
  this.$notify({
            title: "Error",
            message: result.data,
            type: "error"
          });
          }
        })
      }
    },
    getLMSProgress(email) {
      this.loadingProgress = true;
      const progress = LMSapi.getProgress(email);
      Promise.resolve(progress)
        .then(result => {
          this.progress = result.data.data;
          this.loadingProgress = false;
        })
        .catch(e => {
          this.loadingProgress = false;
          this.$notify({
            title: "Error",
            message: "Can't connect to the LMS right now",
            type: "error"
          });
        });
    },
    async printCerts() {
      ///get certs with certSent ==true i.e they are selcted in the ui
      if (this.certificates.length == 0) {
        this.$notify({
          title: "Error",
          message: "No Certificates",
          type: "error"
        });
        return;
      }
      var certsToPrint = _.filter(this.certificates, o => {
        return o.boughtProducts[0].certDue === true;
      });
      this.loadingCertificates = true;
      // generate a single pdf and a merged pdf for printing
      this.certURL = await datas
        .printCertificates({ certificates: certsToPrint })
        .then(res => {
          var dataView = new DataView(res.data);
          var fileURL = window.URL.createObjectURL(
            new Blob([dataView], { type: "application/pdf" })
          );
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "certificates.pdf");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.loadingCertificates = false;
        });
    },
    async printLabels() {
      if (this.certificates.length == 0) {
        this.$notify({
          title: "Error",
          message: "No Certificates",
          type: "error"
        });
        return;
      }
      var certsToPrint = _.filter(this.certificates, o => {
        return o.boughtProducts[0].certDue === true;
      });
      var labelsToPrint = _.map(certsToPrint, "customer");
      //convert the 2 digit coutry codes to names
      labelsToPrint = _.map(labelsToPrint, l => {
        if (l.shippingAddress) {
          l.shippingAddress.country ? getName(l.shippingAddress.country) : "";
          return l;
        } else {
          this.$notify({
            title: "Error",
            message: " A customer does not have an address.",
            type: "error"
          });
          return false;
        }
      });

      this.loadingLabels = true;
      this.labelURL = await datas
        .printLabels({ labels: labelsToPrint })
        .then(res => {
          var dataView = new DataView(res.data);
          //var contentType = res.getResponseHeader('Content-Type')
          var fileURL = window.URL.createObjectURL(
            new Blob([dataView], { type: "text/csv" })
          );
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "labels.csv");
          document.body.appendChild(fileLink);

          fileLink.click();
          this.loadingLabels = false;

          // return res.data.result;
        });
    },
    async printLors() {
      if (this.certificates.length == 0) {
        this.$notify({
          title: "Error",
          message: "No Certificates",
          type: "error"
        });
        return;
      }
      //get the selected customerids
      this.selectedIds = this.certificates
        .filter(o => o.boughtProducts[0].certDue == "1")
        .map(function(o) {
          return o.customer.id;
        });
      this.loadingLors = true;
      const q = gql`
        query getlors($userids: [Int!]) {
          LetterOfReference(where: { customerId: { _in: $userids } }) {
            id
            template
            gender
            believe
            comments
            dateCreated
            customerId
            dateUpdated
            demonstrated
            learnt
            overall1
            overall2
            overall3
            overall4
            planning
            sourceUrl
            support
            understanding
            customer {
              firstname
              middlenames
              lastname
            }
          }
        }
      `;
      await this.$apollo
        .query({
          query: q,
          variables: { userids: this.selectedIds }
        })
        .then(response => {
          //this.lors = response.data;
          // end the lor data to reporting server to gen the merged pdf for printing
          datas.printLors(response.data).then(res => {
            var dataView = new DataView(res.data);
            var fileURL = window.URL.createObjectURL(
              new Blob([dataView], { type: "application/pdf" })
            );
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute(
              "download",
              "lors-" + moment().format("DD/MM/YYYY") + ".pdf"
            );
            document.body.appendChild(fileLink);
            fileLink.click();
            this.loadingLors = false;
          });
        });
    }
  },
  mounted() {
    this.getCertificatesDue();
  }
};
</script>
<style>
.el-checkbox__inner {
  border: 2px solid gray !important;
  width: 25px;
  height: 25px;
}
.el-checkbox__inner::after {
  left: 8px;
  top: 3px;
  height: 12px;
}
</style>
//certs are create via the LMS in /Extensions/TEFLLMS/Components/Extension/Extension.php _afterStart()




// WEBPACK FOOTER //
// src/components/Certificates/List.vue